<template>
    <div class="common_alarm_pop" v-if="!$_WC.is4K && isShowState && typeof popupInfo !== 'undefined'">
        <img :src="getImgUrl(popupInfo)" alt="">
        <div class="top_title">알림 메세지</div>

        <div class="popup_btn_area">
            <input v-model="checkState" type="checkbox" name="checkNoShow" id="promotion_cookie_check" class="chk_no_show"> 
            <label for="promotion_cookie_check">오늘 하루 보지 않기</label> 
        </div>
        <a href="#" @click.prevent="closePopSetTm()" class="alarm_btn_close">닫기</a>
    </div>
</template>

<script>

import commonApi from "@/apis/common.api.js";
import { $_WC, $_TYPE } from "@/confs/common.const.js";

export default {
    data() {
        return {
            popupInfo: {},
            isShowState: false,
            checkState: false,
            isMain: window.location.pathname.indexOf('/main') === -1 ? false : true,
        };
    },
    watch: {
    },
    created() {
        let value = document.cookie.match('(^|;) ?' + 'showPop' + '=([^;]*)(;|$)');
        let bannerCookie = value? value[2] : null;
        if(bannerCookie != 'false' && this.isMain) {
            this.getPopupInfo();
        }
    },
    methods: {
        getPopupInfo() {
            let dataKdSqno = 990;
            let q = '';
            commonApi.fetchRepoDataList(dataKdSqno, q, true).then(res => {
                let data = res.data.data[0];
                let now = new Date().format('yyyyMMddHHmm');
                
                if(!!data) {
                    let startDtm = data.val2;
                    let endDtm = data.val3;
                    if(Number(now) >= Number(startDtm) && Number(now) <= Number(endDtm)) {
                        this.popupInfo = res.data.data[0];
                        this.isShowState = true;
                    }
                }
            });
        },
        getImgUrl(data) {
            let returnUrl = '';
            if(typeof data.dataFiles !== $_TYPE.UNDEF && data.dataFiles.length > 0) {
                let file = data.dataFiles[0];
                returnUrl = $_WC.fileBaseURL + '/image/' + file.comnFlSqno  + "?isOrigin=true&attachFileSaveTpc=db";
            }
            return returnUrl;
        },
        closePopSetTm() {
            if(this.checkState) {
                this.setCookie('showPop', 'false', 1);
                this.isShowState = false;
            } else {
                this.isShowState = false;
            }
        },
        setCookie(name, value, exp) {
            var date = new Date();
            date.setTime(date.getTime() + exp*24*60*60*1000);
            document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
        },
    },
};
</script>
<style>
</style>
